(function () {
  // 2026-10-19 v4 (task pdp-swi-photos). Styled with Intention photos, right sized, load when near.
  // Nils 2026-10-19: "after load or when near". Before the main photo is in, a row starts only when the
  // visitor actually has it on screen (they are looking at it). Once the main photo is in (or the page's
  // load event, when no main photo is found) rows start one screen ahead. So nothing competes with the
  // main photo unless the visitor has already scrolled to the row.
  // Main photo = every large eager / high priority image on the first screen. The markup holds the real
  // address in data-isi-src / data-isi-srcset and a 1x1 transparent gif in src, so each box keeps its size.
  // A product page row scrolls sideways: when it starts, the cards inside the first two row widths load,
  // and the rest load as the visitor swipes towards them.
  function swap(img) {
    var src = img.getAttribute('data-isi-src');
    if (!src) return;
    var set = img.getAttribute('data-isi-srcset');
    img.removeAttribute('data-isi-src');
    img.removeAttribute('data-isi-srcset');
    if (set) img.setAttribute('srcset', set);
    img.setAttribute('src', src);
  }
  function fillRow(row) {
    var r = row.getBoundingClientRect(), lim = r.left + r.width * 2, left = 0;
    var imgs = row.querySelectorAll('img[data-isi-src]');
    for (var i = 0; i < imgs.length; i++) {
      var box = (imgs[i].closest('li') || imgs[i]).getBoundingClientRect();
      if (box.left < lim) swap(imgs[i]); else left++;
    }
    return left;
  }
  var swiped = [];
  function begin(t) {
    if (t.tagName === 'IMG') { swap(t); return; }
    if (swiped.indexOf(t) >= 0) { fillRow(t); return; }
    if (fillRow(t)) {
      swiped.push(t);
      var on = function () { if (!fillRow(t)) t.removeEventListener('scroll', on); };
      t.addEventListener('scroll', on, { passive: true });
    }
  }
  function targets() {
    var imgs = document.querySelectorAll('img[data-isi-src]'), seen = [];
    for (var i = 0; i < imgs.length; i++) {
      var tgt = imgs[i].closest('.isi-pdp__row') || imgs[i];
      if (seen.indexOf(tgt) < 0) seen.push(tgt);
    }
    return seen;
  }
  function watch(margin) {
    var list = targets();
    if (!list.length) return null;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        begin(e.target);
      });
    }, { rootMargin: margin });
    for (var i = 0; i < list.length; i++) io.observe(list[i]);
    return io;
  }
  function whenMainIn(go) {
    var done = false;
    function fire() { if (done) return; done = true; go(); }
    if (document.readyState === 'complete') return fire();
    window.addEventListener('load', fire);
    // page coordinates: a visitor may already have scrolled down when this runs (session 5f49d352 finding)
    var vh = window.innerHeight, vw = window.innerWidth, y = window.pageYOffset || 0, wait = 0, found = 0;
    var c = document.querySelectorAll('img[loading="eager"], img[fetchpriority="high"]');
    function one() { if (--wait <= 0) fire(); }
    for (var i = 0; i < c.length; i++) {
      var r = c[i].getBoundingClientRect();
      if (r.width < 120 || r.height < 120 || r.bottom + y <= 0 || r.top + y >= vh * 1.5 || r.right <= 0 || r.left >= vw) continue;
      found++;
      if (c[i].complete) continue;
      wait++;
      c[i].addEventListener('load', one, { once: true });
      c[i].addEventListener('error', one, { once: true });
    }
    if (found && !wait) fire();
  }
  if (!document.querySelector('img[data-isi-src]')) return;
  if (!('IntersectionObserver' in window)) {
    whenMainIn(function () {
      var imgs = document.querySelectorAll('img[data-isi-src]');
      for (var k = 0; k < imgs.length; k++) swap(imgs[k]);
    });
    return;
  }
  var early = watch('0px');
  whenMainIn(function () {
    if (early) early.disconnect();
    watch('100% 0px');
  });
})();
(function () {
  // Styled with Intention, Style It page: Show more opens the rest of the people grid,
  // and "Go to a Word" jumps to the first card wearing that Word and pulses it twice
  // (scale only, no glow; no movement under reduced motion, handled in CSS).
  var root = document.getElementById('isi');
  if (!root) return;
  var grid = root.querySelector('.isi-grid');
  var more = root.querySelector('[data-isi-more]');
  function open() {
    if (grid) grid.classList.remove('is-collapsed');
    if (more) more.parentNode.hidden = true;
  }
  if (grid && grid.querySelector('[data-more]')) {
    grid.classList.add('is-collapsed');
    if (more) more.addEventListener('click', open);
  } else if (more) {
    more.parentNode.hidden = true;
  }
  root.addEventListener('click', function (ev) {
    var a = ev.target.closest('[data-jump]');
    if (!a || !grid) return;
    var card = grid.querySelector('.isi-p[data-word="' + a.getAttribute('data-jump') + '"]');
    if (!card) return;
    ev.preventDefault();
    if (card.hasAttribute('data-more') && grid.classList.contains('is-collapsed')) open();
    card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    card.classList.remove('is-pulse');
    void card.offsetWidth;
    card.classList.add('is-pulse');
    card.addEventListener('animationend', function off() {
      card.classList.remove('is-pulse');
      card.removeEventListener('animationend', off);
    });
  });
})();
